// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jZTj","toggle":"styles_toggle__3kzet","preview":"styles_preview__xp81G"};